<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  data() {
    return {}
  },

  methods: {
    
  },
  components: {

  },
  created() {

  },
}
</script>

<style lang="scss" rel="stylesheet/scss">
#app {
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// App.vue?201ed2e5